import { CampaignWithoutTagsFragment, UserDetailsFragment } from 'generated/graphql';

export const StateName = 'AuthState';

export interface AuthState {
  current_user?: UserDetailsFragment;
  password_reset_message?: string;
}

export const initialState: AuthState = {
  current_user: null,
  password_reset_message: null,
};
